export default __webpack_public_path__ + "static/media/defiant.ef6feb29.jpeg";